const MONTHS = ["jan","feb","mar","apr","may","jun","jul","aug","sep","oct","nov","dec"];

export const intakeDate = (i) => {
  if (i.start_date) { const d = new Date(i.start_date); if (!isNaN(d)) return d; }
  const m = (i.name || "").toLowerCase().match(/([a-z]+)\D*(\d{2,4})/);
  if (!m) return null;
  const mi = MONTHS.indexOf(m[1].slice(0, 3));
  if (mi < 0) return null;
  const y = m[2].length === 2 ? 2000 + Number(m[2]) : Number(m[2]);
  return new Date(y, mi, 1);
};

// Current intake (latest already started) + next 7, chronological; keeps selected value visible.
export const upcomingIntakes = (intakes = [], selectedId, count = 8) => {
  const dated = intakes.map(i => ({ i, d: intakeDate(i) })).filter(x => x.d).sort((a, b) => a.d - b.d);
  const now = new Date();
  let start = dated.findIndex(x => x.d > now) - 1;
  if (start < 0) start = dated.findIndex(x => x.d > now) === -1 ? Math.max(dated.length - 1, 0) : 0;
  const list = dated.slice(start, start + count).map(x => x.i);
  const sel = selectedId && !list.some(i => i.id === selectedId) && intakes.find(i => i.id === selectedId);
  return sel ? [sel, ...list] : list;
};
